<div class="filter-pane">
  <h1>{{'Filter' | translate}}</h1>
  <div class="column">
    <app-client-dropdown width="80%" [status]="['ACTIVE', 'PASSIVE']" (client)="onClient($event)"></app-client-dropdown>
  </div>
</div>
